module.exports = __webpack_public_path__ + "static/img/collapse-2-icon.8eb4ad5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/collapse-2-icon.png
// module id = zJZb
// module chunks = 7